import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyAtqenrqO16aas-euG9DfMbKdpklQ16d5g",
    authDomain: "turnout-1cfb4.firebaseapp.com",
    databaseURL: "https://turnout-1cfb4.firebaseio.com",
    projectId: "turnout-1cfb4",
    storageBucket: "turnout-1cfb4.appspot.com",
    messagingSenderId: "195454959859"
};

export const firebaseApp = firebase.initializeApp(config)
export const eventsRef = firebaseApp.database().ref().child('events')



// WEBPACK FOOTER //
// ./src/firebaseApp.js